let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lKAjB")).then(() => parcelRequire('arR8o'));